import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

const PASSWORD_SPECIAL_CHARS_PATTERN = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

export type PasswordRequirements = {
  minLength: boolean;
  maxLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasNumber: boolean;
  hasSpecial: boolean;
};

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const password = String(control.value);
    const errors: ValidationErrors = {};

    if (password.length < PASSWORD_MIN_LENGTH) errors['minLength'] = true;
    if (password.length > PASSWORD_MAX_LENGTH) errors['maxLength'] = true;
    if (!/[A-Z]/.test(password)) errors['uppercase'] = true;
    if (!/[a-z]/.test(password)) errors['lowercase'] = true;
    if (!/[0-9]/.test(password)) errors['number'] = true;
    if (!PASSWORD_SPECIAL_CHARS_PATTERN.test(password)) errors['special'] = true;

    return Object.keys(errors).length > 0 ? errors : null;
  };
}

export function getPasswordRequirements(password: string | null | undefined): PasswordRequirements {
  const value = password || '';

  return {
    minLength: value.length >= PASSWORD_MIN_LENGTH,
    maxLength: value.length <= PASSWORD_MAX_LENGTH,
    hasUppercase: /[A-Z]/.test(value),
    hasLowercase: /[a-z]/.test(value),
    hasNumber: /[0-9]/.test(value),
    hasSpecial: PASSWORD_SPECIAL_CHARS_PATTERN.test(value),
  };
}

export function isPasswordStrong(password: string | null | undefined): boolean {
  const requirements = getPasswordRequirements(password);

  return (
    requirements.minLength &&
    requirements.maxLength &&
    requirements.hasUppercase &&
    requirements.hasLowercase &&
    requirements.hasNumber &&
    requirements.hasSpecial
  );
}
